// import { mapGetters } from "vuex";
// import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // eslint-disable-next-line
      asFoundConditionOptions: [
        "Trip",
        "Locked",
        "Broken",
        "Damage",
        "Smoke",
        "Fire",
        "Leak",
        "Spill",
        "Harm",
        "Injury",
        "Major"
      ],
      // eslint-disable-next-line
      hazardOptions: [
        "Electricty",
        "Chemical",
        "Toxic",
        "Heights",
        "Ground",
        "Spill",
        "Gas",
        "Pressure",
        "Other"
      ],
      // eslint-disable-next-line
      hazardBarrierOptions: [
        "Procedure",
        "Training",
        "Maintenance",
        "Inspection",
        "Test",
        "Design",
        "Detection System",
        "Alarm System",
        "Shutdown System",
        "Training"
      ],
      // eslint-disable-next-line
      hazardControlOptions: [
        "Procedure",
        "Evacuation",
        "2 Person",
        "Supervisor",
        "Check",
        "Inspect",
        "Muster Point",
        "Test",
        "First Aid",
        "Rescue Kit",
        "Engineer",
        "Vendor",
        "Senior"
      ],
      // eslint-disable-next-line
      hazardOutcomeOptions: [
        "Alarm",
        "Trip",
        "Leak",
        "Loss",
        "Smoke",
        "Arc",
        "Fire",
        "Release",
        "Collapse",
        "Contamination",
        "Collision",
        "Explosion"
      ],
      // eslint-disable-next-line
      hazardControlEffectiveOptions: [
        "Strong",
        "Weak"
      ],
      // eslint-disable-next-line
      hazardControlAssuranceOptions: [
        "Prestart",
        "Maintenace"
      ],
      // eslint-disable-next-line
      hazardThemeOptions: [
        "Electricty",
        "Gas",
        "Liquid",
        "Energy",
        "Pressure",
        "Noise",
        "Weather",
        "Radiation",
        "Ergonomic",
        "Occupational",
        "Chemical",
        "Physical",
        "Toxic",
        "Acids",
        "Biology",
        "Other"
      ],
      // eslint-disable-next-line
      hazardLevelOptions: [
        "Company",
        "Facility",
        "Asset",
        "Equipment",
        "Material"
      ],
      // eslint-disable-next-line
      hazardTypeOptions: [
        "Company",
        "Facility"
      ],
      // eslint-disable-next-line
      hazardConditionOptions: [
        "Operations",
        "Maintenance",
        "Project",
        "Startup",
        "Shutdown",
        "Isolation"
      ]
    };
  }
};
